import { createApp } from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import router from './router'

const app = createApp(App)
app.use(router)
app.mount('#app')
console.log('test')
